
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { EventService } from 'src/app/services/event.service';
import { SessionContextService } from 'src/app/services/session-context.service';
import { Employee } from 'src/app/shared/model/employee.model';
import { Branch } from '../shared/model/Branch.model';
import { TerminalSelection, TerminalSelectionComponent } from '../shared/components/terminal-selection/terminal-selection.component';
import { OpenTillComponent } from '../shared/components/open-till/open-till.component';
import { EmployeeService } from '../services/employee.service';
import { take } from 'rxjs/operators';
import { AS365Defaults } from '../shared/model/AS365Defaults.model';
import { DefaultDataService } from '../services/default-data.service';
import { alert } from 'devextreme/ui/dialog';
import { ResourceManagerService } from '../services/resource.manager.service';

@Component({
  selector: 'app-login-dashboard',
  templateUrl: './login-dashboard.component.html',
  styleUrls: ['./login-dashboard.component.css']
})
export class LoginDashboardComponent implements OnInit, OnDestroy {

  appTitle: string;
  ShutdownTitle = 'Shutdown';
  employees: Employee[] = [];
  fullEmployeeList: Employee[] = [];

  paramEmployeeId = -1;

  employeeId = -1;
  btnLoginEnabled = false;
  ShowInvalidPinMessage = false;

  private onDefaultDataChanged$: Subscription;
  private onBranchChanged$: Subscription;

  @ViewChild('pinEntry') pinEntryField: ElementRef;
  @ViewChild(TerminalSelectionComponent) dlgTerminal: TerminalSelectionComponent;
  @ViewChild(OpenTillComponent) dlgOpenTill: OpenTillComponent;

  private UID: string = null;
  LoginRoute = '/frontoffice/aptbook';

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private defaultData: DefaultDataService,
    private events: EventService,
    private session: SessionContextService,
    private employeeAuth: EmployeeService,
    private resourceManagerService: ResourceManagerService) {

    console.log("Checkin Page ctor");
    this.OnCloseTerminalDlg = this.OnCloseTerminalDlg.bind(this);

    this.onDefaultDataChanged$ = this.events.onDefaultDataChanged.pipe(take(1)).subscribe((d) => {
      if (d) this.InitFromDefaultData(d);
    });

    this.onBranchChanged$ = this.events.onBranchChanged.subscribe(b => {
      if (b) {
        this.employees = this.processEmployees();
      }
    });

    // Force get of default data to ensure we have latest
    defaultData.GetDefaultData();
  }

  ngOnInit() {

    // Init data
    // this.InitFromDefaultData(this.session.defaultData.defData);

    // force user logout
    this.session.selectEmployee(-1, null).pipe(take(1)).subscribe();

    this.UID = null;
    this.UID = this.activatedRoute.snapshot.paramMap.get('UID');
    if (this.UID && this.UID.length < 5)
      this.UID = null;
  }

  InitFromDefaultData(d: AS365Defaults) {
    if (d) {
      this.appTitle = d.AppTitle;
      this.ShutdownTitle = 'Logout and close ' + d.AppTitle;
      this.fullEmployeeList = d.Employees;
      this.employees = this.processEmployees();

      if (this.UID != null && this.UID.length >= 5) {
        // We have a login as user here, so find user from full list of employees
        var e = d.Employees.find(i => i.UID == this.UID);
        if (e) {
          // Select their branch
          if (e.BranchId)
            this.session.selectBranch(e.BranchId);

          // Check in employee
          console.log("Login As : " + e);
          this.loginEmployee(e.EmployeeId);
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.onDefaultDataChanged$) {
      this.onDefaultDataChanged$.unsubscribe();
    }
    if (this.onBranchChanged$) {
      this.onBranchChanged$.unsubscribe();
    }
  }

  processEmployees(): Employee[] {
    const b: Branch = this.session.GetSelectedBranch();
    // let BranchEmployeeList: Employee[] = this.defaultData.Employees;
    // if (b != null) {
    //   BranchEmployeeList = this.fullEmployeeList.filter(i => i.BranchId === b.BranchId || i.BranchId == null || i.IsAdmin === true);
    // }
    this.fullEmployeeList.forEach((e) => {
      e.Selected = false;
    });
    return this.fullEmployeeList.filter(i => i.Active && (i.BranchId === b.BranchId || i.BranchId == null || i.IsAdmin === true));
  }

  private UpdateControls() {
    const s = this.pinEntryField.nativeElement.value;
    this.btnLoginEnabled = (s.length === 4) && (this.employeeId !== -1);
  }

  private loginEmployee(employeeId: number) {
    if (employeeId) {
      this.EmployeeClicked(employeeId);
      this.pinEntryField.nativeElement.value = '0000';
      this.btnLogInClicked();
    }
  }

  public EmployeeClicked(employeeId) {    
    this.employeeId = employeeId;

    const e = this.fullEmployeeList.find(i => i.EmployeeId === employeeId);
    if (e != null) {
      this.employees.forEach(i => i.Selected = false);
      e.Selected = true;
    }
    this.ShowInvalidPinMessage = false;
    if (this.pinEntryField) {
      this.pinEntryField.nativeElement.value = '';
      this.pinEntryField.nativeElement.focus();
      this.UpdateControls();
    }
  }

  public btnPressNumber(c) {
    if (this.pinEntryField.nativeElement.value == null) {
      this.pinEntryField.nativeElement.value = '';
    }
    const l = this.pinEntryField.nativeElement.value.length;
    if (l >= 4) {
      return;
    }
    this.pinEntryField.nativeElement.value = this.pinEntryField.nativeElement.value + c;
    this.ShowInvalidPinMessage = false;
    this.UpdateControls();
  }

  public pinInputChanged(e) {
    this.ShowInvalidPinMessage = false;
    this.UpdateControls();
    if (this.btnLoginEnabled && (e.key === "Enter")) {
      this.btnLogInClicked();
    }
  }

  public btnClear() {
    this.ShowInvalidPinMessage = false;
    this.pinEntryField.nativeElement.value = null;
    this.UpdateControls();
  }

  public btnBackSpace() {
    this.ShowInvalidPinMessage = false;
    const l = this.pinEntryField.nativeElement.value.length;
    if (l < 1) {
      return;
    }
    this.pinEntryField.nativeElement.value = this.pinEntryField.nativeElement.value.substring(0, l - 1);
    this.UpdateControls();
  }

  public btnLogInClicked() {    
    // Call WebAPI to validate Employees PIN with entered pin number
    let pinString = this.pinEntryField.nativeElement.value;
    if (this.UID != null && this.UID.length > 5) {
      pinString = '0000';
    }

    this.session.selectEmployee(this.employeeId, pinString).pipe(take(1)).subscribe(r => {
      if (r.Success) {

        // Login Pin successful.

        // Save After login route
        if (!r.Msg || r.Msg == "")
          r.Msg = "/frontoffice/aptbook";

        console.log("After Login nav to : " + r.Msg);
        this.LoginRoute = r.Msg;

        // determine terminal or register
        this.dlgTerminal.show(this.LoginRoute);

        // Next in sequence
        // 1. Show OpenTill if needed
        // 2. Nav to Appointment Book
        //    this.router.navigateByUrl(r.Msg);
      } else {
        // Reset PIN field
        this.btnClear();

        // Show invalid pin message
        this.ShowInvalidPinMessage = true;
      }
    });
  }

  public btnShutdownClicked() {
    window.location.assign("/account/logout");
    // this.router.navigateByUrl('/account/logout');
  }

  OnCloseTerminalDlg(e: TerminalSelection) {
    // Register the login with webAPI so we can track employee's logged in time. We need to do it here
    // because an employee can be logged into more than one
    // terminal at a time and so we need the terminal ID which is obtained in the Select Terminal Dlg.

    // Ensure all components know about the selected terminal
    this.events.TerminalChanged(e.terminal);

    this.employeeAuth.RecordEmployeeLogin(this.session.ctx.EmployeeId, this.session.ctx.BranchId, this.session.ctx.TerminalId)
      .pipe(take(1)).subscribe(r => {
        if (e && e.terminal.TillConnected) {
          // Show Open Till dlg
          this.dlgOpenTill.show(e.returnUrl);
        } else {
          this.checkResourceAvailability();
          this.NavToPostLoginRoute(e.returnUrl);
        }
      });
  }

  OnCloseOpenTillDlg(e) {
    this.checkResourceAvailability();
    this.NavToPostLoginRoute(e.returnUrl);
  }

  NavToPostLoginRoute(returnUrl: string) {
    this.router.navigateByUrl(returnUrl);
  }

  checkResourceAvailability() {
    this.resourceManagerService
      .checkResourceAvailabilityExpiry(this.session.ctx.BranchId)
      .pipe(take(1))
      .subscribe((availability) => {
        if (availability) {
          if (availability.expired) {
            alert(
              'YOU HAVE AVAILABILITY RECORDS THAT HAVE EXPIRED AND YOU CANNOT MAKE APPOINTMENTS FOR THOSE RESOURCES',
              'Resource availability expired'
            );
          }
          if (availability.expiryDate) {
            alert(
              'You have availability records that are due to expire on ' +
                availability.expiryDate +
                '. Please check and add new records if required',
              'Resource availability due to expire'
            );
          }
        }
      });
  }
}
